import { tCartProduct, tDetailedCart } from "tmt_api/src/types/types";

import { getBalancePrefix } from "../env";

type tpOpenCheckout = (myCheckoutToken: Array<string>, onSuccess: () => void) => void;
export const openCheckout: tpOpenCheckout = (myCheckoutToken, onSuccess) => {
  window.blnceCheckout
    .create({
      // The token that returned from the server API
      checkoutTokens: myCheckoutToken,
      url: `https://checkout.${getBalancePrefix}getbalance.com/checkout.html`,
      type: "checkout",
      hideBackOnFirstScreen: false,
      logoURL: "https://themaintab.com/tmt_logo.png",
      isAuth: true,
      onSuccess,
      onComplete: () => {
        // this function must be defined
      },
      onError: (error) => {
        if (error.error?.code === "card_declined") {
          const popup = window.document.getElementById("blnce-checkout-popup");
          if (popup) {
            popup.innerHTML += `
              <div class="modal-overlay"></div>
              <div class="modal-body">
                <div onclick="closeBalanceCheckoutPopup()" title="Close" class="modal-close">X</div>
                <h1 class="modal-title">Update Your Credit Card</h1>
                <div class="modal-content">
                  <p>NET Terms are disabled as the card isn't working. Please update your credit card and try again.</p>
                </div>
              </div>
            `;
          }
        }
      },
      callback: (err: Error, msg: string) => {
        console.log("msg from the iframe -", msg);
        console.log("err", err);
      },
      onClose: () => {
        window.blnceCheckout.destroy();
      },
    })
    // This element should exist on the dom
    .render("#blnce-checkout");
};

export const sortByBrandName = (a: tDetailedCart, b: tDetailedCart): number => {
  if (a.name < b.name) {
    return -1;
  } else if (a.name > b.name) {
    return 1;
  } else {
    return 0;
  }
};
export const sortBySku = (myLeftCartProduct: tCartProduct, myRightCartProduct: tCartProduct): number => {
  const aLeft = myLeftCartProduct.actualSKU.toUpperCase(); // ignore upper and lowercase
  const aRight = myRightCartProduct.actualSKU.toUpperCase(); // ignore upper and lowercase
  if (aLeft < aRight) {
    return -1;
  }
  if (aLeft > aRight) {
    return 1;
  }

  // names must be equal
  return 0;
};

export const quantityChange = (qNumber: number, inventory: number, caseMin: number): number => {
  if (qNumber >= inventory) {
    return Math.max(0, Math.floor(inventory / caseMin) * caseMin);
  } else {
    return Math.max(0, Math.round(qNumber / caseMin) * caseMin);
  }
};

export const getProductInfoFromCartProduct = (
  cartProduct: tCartProduct,
): { inventory: number; caseMinimum: number; isTester: boolean } => {
  if (cartProduct.variants.length > 0) {
    const cartVariantProduct = cartProduct.variants?.find(
      (variant) => variant.tester?.sku === cartProduct.actualSKU || variant.sku === cartProduct.actualSKU,
    );
    const isTester = cartProduct.actualSKU !== cartVariantProduct?.sku;
    return {
      inventory: cartVariantProduct?.inventory ?? 0,
      caseMinimum: isTester ? 1 : cartProduct.case_minimum,
      isTester,
    };
  } else {
    const isTester = cartProduct.actualSKU === cartProduct.tester?.sku;
    return {
      inventory: cartProduct.inventory,
      caseMinimum: isTester ? 1 : cartProduct.case_minimum,
      isTester,
    };
  }
};
